import { FC, useEffect } from "react";

import { useQuery } from "react-query";
import { useParams } from "react-router-dom";

import { conversationApi } from "@/shared/apis";
import { ContextualConversationLoaderState, CONVERSATION_NEW_ID, ConversationObjectType } from "@/shared/domain";
import { useNavigation, useRouterHook } from "@/shared/hooks";

type ContextualParams = {
    objectId: string;
    objectType: ConversationObjectType;
};

const ContextualConversationLoader: FC = () => {
    const {
        state: { objectTitle, policyholderId },
    } = useRouterHook<ContextualConversationLoaderState>();
    const { navToConversationDetail } = useNavigation();
    const { objectId, objectType } = useParams<ContextualParams>();

    const {
        data: conversation,
        isSuccess,
        isError,
    } = useQuery(
        [
            "contextualConversation",
            {
                objectType,
                objectId,
            },
        ],
        () => conversationApi.getContextualConversation(objectType, objectId),
        {
            useErrorBoundary: false,
        },
    );

    useEffect(() => {
        if (conversation && isSuccess) {
            navToConversationDetail({
                conversationId: conversation.id,
                policyholderId: policyholderId,
                title: conversation.topic,
            });
        } else if (isError) {
            navToConversationDetail({
                conversationId: CONVERSATION_NEW_ID,
                policyholderId: policyholderId,
                title: objectTitle,
                objectId,
                objectType,
            });
        }
    }, [conversation, isSuccess, isError]);

    return <></>;
};

export default ContextualConversationLoader;
